module.exports = __webpack_public_path__ + "img/keep.da665866.png";